"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Busy = void 0;
exports.useInterval = useInterval;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Layout_1 = require("../Layout");
const Text_1 = require("../Text");
const styled_components_1 = require("../styled-components");
const react_2 = require("react");
function useInterval(callback, delay) {
    const savedCallback = (0, react_2.useRef)(callback);
    // Remember the latest callback.
    (0, react_2.useEffect)(() => {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval.
    (0, react_2.useEffect)(() => {
        function tick() {
            if (savedCallback.current)
                savedCallback.current();
        }
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
}
const Loader = styled_components_1.styled.div `
  width: ${({ size = 16 }) => size}px;
  height: ${({ size = 16 }) => size}px;
  flex: 0 0 ${({ size = 16 }) => size}px;

  background: linear-gradient(
    rgba(255, 255, 255, 0.1) 40%,
    ${({ theme }) => theme.highlight}
  );
  border-radius: 50%;

  position: relative;
  transform: translateZ(0);
  animation:
    spin 0.6s infinite linear,
    appear 0.3s ease-in;

  &::before {
    content: "";
    width: 70%;
    height: 70%;
    flex: 0 0 70%;

    position: absolute;
    z-index: 10;

    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    background: #282828;
    border-radius: 50%;
    border: none;
    box-shadow: none;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes appear {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
exports.Busy = react_1.default.memo(({ show, message }) => {
    const [duration, setDuration] = react_1.default.useState(0);
    useInterval(() => {
        setDuration(duration + 1);
    }, 1000);
    return show ? (react_1.default.createElement(Layout_1.Flex, { "data-testid": "busy spinner", align: "center", noWrap: true, noOverflow: true, noGrow: true },
        react_1.default.createElement(Loader, null),
        message && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Layout_1.FlexSpace, null),
            react_1.default.createElement(Text_1.Subtle, { noTitle: true }, duration > 3 ? `${message} (${duration}s)` : message))))) : null;
});
//# sourceMappingURL=index.js.map